import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { IGroupInfo, IGroupServiceSelectorService } from "./groupOrderServiceSelector.facade";
import { TableData, Table } from "../../services/IInHouseOrderService";
import Utils from "../../shared/utils";
import { CoreLogService } from "../../services/log.service";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { Router } from "@angular/router";
import { WarningdialogComponent } from "../../modalDialogs";

class GroupInfo implements IGroupInfo {
  groupName: string = "";
  groupCreator: string = "";
}

@Injectable()
export class GroupOrderServiceSelectorService implements IGroupServiceSelectorService, OnDestroy {
  private _inHouseTableChangedSub: Subscription;
  private _inHouseTableClosedSub: Subscription;

  constructor(private _inHouseOrderService: InHouseOrderService,
    private _coreLogService: CoreLogService,
    private _bottomSheetHelperService: BottomSheetHelperService,
    private _router: Router
  ) {
    const me = this;

    me._groupInfoSubject.next({
      groupName: me._inHouseOrderService.GroupName,
      groupCreator: me._inHouseOrderService.GroupCreator
    });

    // null damit kein unnötiger Abruf stattfindet
    me._inHouseOrderService.GetTable(null).then((table) => {
      me.rebindInHouseTable(table);
    }).catch((error) => {
      me._coreLogService.error("GroupOrderServiceSelectorService.constructor", "inHouseOrderService.GetTable catch", error);
    });

    me._inHouseTableChangedSub = me._inHouseOrderService.ObserveOnTableChanged.subscribe(async (_) => {
      const table = await me._inHouseOrderService.GetTable(null); // null damit kein unnötiger Abruf stattfindet
      me.rebindInHouseTable(table);
    });

    me._inHouseTableClosedSub = me._inHouseOrderService.ObserveOnTableClosedChanged.subscribe((_) => {
      me.OpenWarningLinkExpired();
    });
  }

  ngOnDestroy(): void {
    // Führt Cleanup durch
    const me = this;

    if (me._inHouseTableChangedSub)
      me._inHouseTableChangedSub.unsubscribe();
    if (me._inHouseTableClosedSub)
      me._inHouseTableClosedSub.unsubscribe();
  }

  /** bindet die Werte welche vom aktuellen Tisch Abhängig sind */
  private async rebindInHouseTable(table: Table): Promise<void> {
    const me = this;

    me._setReadyForPickUpCount(me._inHouseOrderService.GetReadyForPickUpCount(table));

    me._setHasOpenItems(table.posTable.items.length > 0);

    let groupBasket_itemsCount = 0;
    let groupBasket_itemsAmount = 0;
    table.yasTable.group_basket_items.forEach(item => {
      groupBasket_itemsCount += item.amount;
      groupBasket_itemsAmount += item.amount * item.price;
    });
    me._setGroupBasketCount(groupBasket_itemsCount);
    me._setGroupBasketPrice(Utils.centsToCurrency(groupBasket_itemsAmount));
  }

  /** use _setGroupBasketPrice */
  private _groupBasketPrice: number = 0;
  /** aktualisiert den offenen Preis */
  private _setGroupBasketPrice(value: number): void {
    const me = this;
    if (me._groupBasketPrice != value) {
      me._groupBasketPrice = value;
      me._groupBasketPriceSubject.next(value);
    }
  }
  private _groupBasketPriceSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public get group_basket_price$(): Observable<number> {
    return this._groupBasketPriceSubject.asObservable();
  }

  /** use _setGroupBasketCount */
  private _groupBasketCount: number = 0;
  /** aktualisiert die anzahl offener Artikel */
  private _setGroupBasketCount(value: number): void {
    const me = this;
    if (me._groupBasketCount != value) {
      me._groupBasketCount = value;
      me._groupBasketCountSubject.next(value);
    }
  }
  private _groupBasketCountSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public get group_basket_count$(): Observable<number> {
    return this._groupBasketCountSubject.asObservable();
  }

  /** use _setReadyForPickUpCount */
  private _readyForPickUpCount: number = 0;
  /** aktualisiert nicht abgeholter artikel */
  private _setReadyForPickUpCount(value: number): void {
    const me = this;
    if (me._readyForPickUpCount != value) {
      me._readyForPickUpCount = value;
      me._readyForPickUpCountSubject.next(value);
    }
  }
  private _readyForPickUpCountSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public get readyForPickUpCount$(): Observable<number> {
    return this._readyForPickUpCountSubject.asObservable();
  }

  /** use _setHasOpenItems */
  private _hasOpenItems: boolean = false;
  /** aktualisiert den offenen Preis */
  private _setHasOpenItems(value: boolean): void {
    const me = this;
    if (me._hasOpenItems != value) {
      me._hasOpenItems = value;
      me._hasOpenItemsSubject.next(value);
    }
  }
  private _hasOpenItemsSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get has_open_items$(): Observable<boolean> {
    return this._hasOpenItemsSubject.asObservable();
  }

  private _groupInfoSubject: BehaviorSubject<IGroupInfo> = new BehaviorSubject<IGroupInfo>(new GroupInfo());
  public get GroupInfo$(): Observable<IGroupInfo> {
    return this._groupInfoSubject.asObservable();
  }

  /** Warning dialog: table / group closed */
  private OpenWarningLinkExpired() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phGroupOrder_LinkExpired_Title"
        , content: "phGroupOrder_LinkExpired_SubText"
        , btnLabel: "phGroupOrder_LinkExpired_Btn"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      if (result) {
        me._router.navigate(["/menuservice"]);
      }
    });
  }
}